import { useMutation, useQuery } from "react-query";
import { useDispatch, useSelector } from "react-redux";
import { planBTMapState } from "../../redux/planBT.mapstate";
import { planBTAPI } from "../../services/planAPI";
import { useEffect } from "react";
import planBTActions from "../../redux/planBT.actions";
import { AxiosError } from "axios";
import { PlanBTPatch } from "../../types/planBT.types";
import { FileUrl } from "../../../../common/components/molecule/FileListManager/FileListManager";
export type CallbackFunction = (result: { result?: any; error?: any }) => void;

export interface Config {
  getCurrentPage: () => number | null;
  getQuerySearch: () => string;
  setQuerySearch?: (querySearch: string | null) => void;
  goToPage: (page: number) => void;
  getAccoundId?: () => string | null;
  getUserId?: () => string | null;
  setHeaderAuthToFutureResquest?: () => void;
}

export default function usePlanBTCore({
  getCurrentPage,
  getQuerySearch,
  setQuerySearch: setQuerySearchToParam,
  getAccoundId,
  getUserId,
  goToPage,
  setHeaderAuthToFutureResquest,
}: Config) {
  const currentPage = getCurrentPage();

  const { planBT: planBtState } = useSelector(planBTMapState);
  const dispatch = useDispatch();

  setHeaderAuthToFutureResquest && setHeaderAuthToFutureResquest();

  const allPlanBTQuery = useQuery({
    queryKey: ["planBT", currentPage, planBtState.querySearch],
    queryFn: () =>
      planBTAPI.getAllPlanBT(currentPage || 1, 10, {
        querySearch: planBtState.querySearch,
      }),
  });

  useEffect(() => {
    if (currentPage) {
      setPage(Number(currentPage));
    }
  }, [currentPage]); // eslint-disable-line
  const setPage = (page: number) => {
    goToPage && goToPage(page);
  };

  const setPlanBtListIsLoading = (isLoading: boolean) => {
    dispatch(planBTActions.setIsLoadingListPlanBTAction(isLoading));
  };

  const setQuerySearch = (querySearch: string | null) => {
    setQuerySearchToParam && setQuerySearchToParam(querySearch);
    dispatch(planBTActions.setQuerySearchAction(querySearch));
  };

  const createNewPlanBT = useMutation({
    mutationFn: ({
      plan,
      file,
      callbackFunc,
    }: {
      plan: PlanBTPatch;
      file?: FileUrl;
      callbackFunc?: CallbackFunction;
    }) =>
      planBTAPI
        .createPlanBT(plan, file)
        .then((result) => {
          callbackFunc && callbackFunc({ result });
        })
        .catch((error) => {
          callbackFunc && callbackFunc({ error });
          return Promise.reject(error);
        }),

    onSettled: () => {
      allPlanBTQuery.refetch();
    },

    onSuccess: () => {
      allPlanBTQuery.refetch();
    },
  });

  const deletePlanBT = useMutation({
    mutationFn: ({
      planBTId,
      callbackFunc,
    }: {
      planBTId: string;
      callbackFunc?: CallbackFunction;
    }) =>
      planBTAPI
        .deletePlanBT(planBTId)
        .then((result) => {
          callbackFunc && callbackFunc({ result });
        })
        .catch((error) => {
          callbackFunc && callbackFunc({ error });
          return Promise.reject(error);
        }),
    onSettled: () => {
      allPlanBTQuery.refetch();
    },
    onSuccess: () => {
      allPlanBTQuery.refetch();
    },
  });

  return {
    allPlanBTQuery: {
      data: allPlanBTQuery.data,
      isLoading: allPlanBTQuery.isLoading || planBtState.isLoadingListPlanBT,
      isError: allPlanBTQuery.isError,
      error: allPlanBTQuery.error as AxiosError,
      refetch: allPlanBTQuery.refetch,
      isRefetching: allPlanBTQuery.isRefetching,
      currentPage,
      setPage,
      setPlanBtListIsLoading,
      setQuerySearch,
      getQuerySearch,
    },

    createNewPlanBT: {
      ...createNewPlanBT,
      error: createNewPlanBT.error as AxiosError,
    },

    deletePlanBT: {
      ...deletePlanBT,
      error: deletePlanBT.error as AxiosError,
    },
  };
}
